<mat-card id="card" fxLayout="column" class="mainContentBody">
    <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
      <h2>Dettaglio turno reperibilità</h2>
      <div fxLayout="column" class="responsive-mat-form">
        <form [formGroup]="form" fxLayout="column">
          <!-- Id field -->
          <mat-form-field>
            <input matInput formControlName="id" placeholder="Turno Id" readonly="true" />
          </mat-form-field>

          <!-- Collaboratore field -->
          <mat-form-field fxLayout="column">
            <mat-label>Collaboratori</mat-label>
            <mat-select formControlName="collaboratore" [compareWith]="compareDTO"
              [disabled]="!isJappTenantAdmin()" >
              <mat-option *ngFor="let collaboratore of collaboratori" [value]="collaboratore">
                {{collaboratore.nome}} {{collaboratore.cognome}} ({{collaboratore.telefonoReperibilita}})
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('collaboratore').errors?.required">
              Campo obbligatorio
            </mat-error>
          </mat-form-field>

          <!-- numeroReperibilita field -->
          <mat-form-field fxLayout="column">
            <mat-label>Numero reperibilità</mat-label>
            <mat-select formControlName="numeroReperibilita" [compareWith]="compareDTO"
              [disabled]="!isJappTenantAdmin()">
              <mat-option *ngFor="let numero of numeri" [value]="numero">
                {{numero.mainNumber}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('numeroReperibilita').errors?.required">
              Campo obbligatorio
            </mat-error>
          </mat-form-field>
  
          <!-- giorno field -->
          <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
            [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
            [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
            <mat-select name="giorno" [disabled]="!isJappTenantAdmin()" formControlName="giorno"
              placeholder="Scegli il giorno">
              <mat-option *ngFor="let option of giorno" [value]="option">
                {{translate(option)}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('giorno').errors?.required">
              Campo obbligatorio
            </mat-error>
          </mat-form-field>
  
          
          <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" class="responsive-mat-form">
            <!-- TimeDa field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput readonly [min]="'00:00'" [max]="'23:59'" [ngxTimepicker]="toggleTimepickerDa" [format]="24"
                formControlName="oraDa" placeholder="Scegli ora da">
              <ngx-material-timepicker #toggleTimepickerDa [preventOverlayClick]="false" [minutesGap]="5"></ngx-material-timepicker>
              <mat-error *ngIf="form.get('oraDa').errors?.required">
                Campo obbligatorio
              </mat-error>
            </mat-form-field>
            <!-- TimeA field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput readonly [min]="'00:00'" [max]="'23:59'" [ngxTimepicker]="toggleTimepickerA" [format]="24"
                formControlName="oraA" placeholder="Scegli ora a">
              <ngx-material-timepicker #toggleTimepickerA [preventOverlayClick]="false" [minutesGap]="5"></ngx-material-timepicker>
              <mat-error *ngIf="form.get('oraA').errors?.required">
                Campo obbligatorio
              </mat-error>
            </mat-form-field>
          </div>


          <!-- Campi di informazione operazione -->
          <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Dettagli operazione
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div fxLayout="row">
              <!-- InsertDate field -->
              <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
                [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
              </mat-form-field>
  
              <!-- InsertUser field -->
              <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
                <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
              </mat-form-field>
            </div>
            <div fxLayout="row">
              <!-- UpdateDate field -->
              <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
                [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
              </mat-form-field>
  
              <!-- UpdateUser field -->
              <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
                <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
              </mat-form-field>
            </div>
          </mat-expansion-panel>
        </form>
      </div>
      <mat-card-actions>
        <button mat-raised-button (click)="backConfirm('/turni-reperibilita')" color="primary">Back</button>
        <button mat-raised-button (click)="turnoSave()" [disabled]="form.invalid || !form.dirty"
          *ngIf="turno?.deleteDate==null">Save</button>
        <button mat-raised-button (click)="turnoDelete()" [disabled]="turno?.id==null"
          *ngIf="turno?.deleteDate==null">Delete</button>
      </mat-card-actions>
    </mat-card-content>
  </mat-card> 